/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

function useCalendarClass(props, state) {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var body = computed(function () {
    return ["".concat(prefixClass.value), "".concat(prefixClass.value, "--").concat(props.theme)];
  });
  var panel = computed(function () {
    return ["".concat(prefixClass.value, "__panel"), "".concat(prefixClass.value, "__panel--").concat(state.curSelectedMode)];
  });
  var control = computed(function () {
    return ["".concat(prefixClass.value, "__control")];
  });
  var title = computed(function () {
    return ["".concat(prefixClass.value, "__title")];
  });
  var controlSection = computed(function () {
    return ["".concat(prefixClass.value, "__control-section")];
  });
  var controlSectionCell = computed(function () {
    return ["".concat(prefixClass.value, "__control-section-cell")];
  });
  var controlTag = computed(function () {
    return ["".concat(prefixClass.value, "__control-tag")];
  });
  var table = computed(function () {
    return ["".concat(prefixClass.value, "__table")];
  });
  var tableHead = computed(function () {
    return ["".concat(prefixClass.value, "__table-head")];
  });
  var tableHeadRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-row")];
  });
  var tableHeadCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-head-cell")];
  });
  var tableBody = computed(function () {
    return ["".concat(prefixClass.value, "__table-body")];
  });
  var tableBodyRow = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-row")];
  });
  return {
    body: body,
    panel: panel,
    control: control,
    title: title,
    controlSection: controlSection,
    controlSectionCell: controlSectionCell,
    controlTag: controlTag,
    table: table,
    tableHead: tableHead,
    tableHeadRow: tableHeadRow,
    tableHeadCell: tableHeadCell,
    tableBody: tableBody,
    tableBodyRow: tableBodyRow
  };
}
function useCalendarCellClass() {
  var prefixClass = usePrefixClass(COMPONENT_NAME);
  var tableBodyCell = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell")];
  });
  var tableBodyCell4Now = computed(function () {
    return "".concat(prefixClass.value, "__table-body-cell--now");
  });
  var tableBodyCellDisplay = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-display")];
  });
  var tableBodyCellCsontent = computed(function () {
    return ["".concat(prefixClass.value, "__table-body-cell-content")];
  });
  return {
    tableBodyCell: tableBodyCell,
    tableBodyCell4Now: tableBodyCell4Now,
    tableBodyCellDisplay: tableBodyCellDisplay,
    tableBodyCellCsontent: tableBodyCellCsontent
  };
}

export { useCalendarCellClass, useCalendarClass };
//# sourceMappingURL=useCalendarClass.mjs.map
